import { useState } from 'react'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import HouseSeasonalBusynessCalendarMonthsGrid from './components/grid/HouseSeasonalBusynessCalendarMonthsGrid'
import HouseSeasonalBusynessCalendarHeader from './components/header/HouseSeasonalBusynessCalendarHeader'
import HouseOptionSubmit from '../house-options-submit/HouseOptionSubmit'
import { HouseSeasonalBusynessCalendar } from '../../../../../../lib/graphql'
import { breakpoints, useMediaQuery } from '../../../../../../lib/hooks'
import { Container } from '../../../../../layout'
import { HouseOptionsFormLayoutProps } from '../../../HouseOptionsForm'

export type HouseSeasonalBusynessCalendarFormProps = {
  updateSeasonalBusynessCalendar: {
    mutate: (formData: HouseSeasonalBusynessCalendar[]) => void
    isLoading: boolean
  }
}

export const HouseSeasonalBusynessCalendarForm = ({
  handleOnExpand,
  house,
  isDisabled,
  isOpen,
  layoutProps: { numberOfCards, parentHeight },
  updateSeasonalBusynessCalendar,
}: HouseSeasonalBusynessCalendarFormProps & HouseOptionsFormLayoutProps) => {
  const intl = useIntl()
  const isMobile = useMediaQuery(breakpoints.newMobile)
  const {
    options: { seasonalBusynessCalendar },
  } = house

  if (!seasonalBusynessCalendar?.[0]) {
    return null
  }

  const [hasRequestBeenSent, setHasRequestBeenSent] = useState<boolean>(false)

  const methods = useForm<HouseSeasonalBusynessCalendar[]>({
    // The array needs to be mapped into an object
    defaultValues: { ...Object.values(seasonalBusynessCalendar) },
  })
  const {
    reset,
    formState: { isSubmitting, isValid, isDirty },
    handleSubmit,
  } = methods

  const { mutate } = updateSeasonalBusynessCalendar

  const timeOutRequest = () => {
    setHasRequestBeenSent(true)
    setTimeout(() => setHasRequestBeenSent(false), 2000)
  }

  const onSubmit = (formData: HouseSeasonalBusynessCalendar[]) => {
    // The object needs to be mapped into an array
    const formDataArray = Object.values(formData)

    mutate(formDataArray)

    reset(formDataArray)

    timeOutRequest()
  }
  const isFieldDisabled = isDisabled || hasRequestBeenSent

  return (
    <FormProvider {...methods}>
      <Container
        title={intl.formatMessage({
          id: 'ui.HouseSeasonalBusynessCalendarForm.title',
          defaultMessage: 'Définir les saisons',
        })}
        isCollapsible={!isMobile}
        isOpened={isOpen}
        toggleCard={handleOnExpand}
        style={{ width: !isMobile ? '100%' : 'auto' }}
        styleTitle={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}
        styleContent={{
          height: '100%',
          paddingRight: '20px',
          paddingLeft: '20px',
        }}
      >
        <div
          style={{
            maxHeight: `calc(${parentHeight}px - ${numberOfCards * 62}px - 30px - 50px - 20px)`,
            overflowX: 'hidden',
          }}
          className={s.form}
        >
          <div className={s.fields}>
            <span className={s.description}>
              <FormattedMessage
                id='ui.HouseSeasonalBusynessCalendarForm.clicSeason '
                defaultMessage='Cliquez sur chaque quinzaine pour définir la saison'
              />
            </span>
            <HouseSeasonalBusynessCalendarHeader />

            <HouseSeasonalBusynessCalendarMonthsGrid
              disabled={isFieldDisabled || !isValid}
            />
          </div>
        </div>

        <HouseOptionSubmit
          confirm={hasRequestBeenSent}
          isValid={isValid}
          isLoading={isSubmitting || updateSeasonalBusynessCalendar.isLoading}
          onSubmit={handleSubmit(onSubmit)}
          disabled={isFieldDisabled || !isDirty || !isValid}
        />
      </Container>
    </FormProvider>
  )
}
